import { Box, BoxProps } from '@chakra-ui/react/box';

export type PageProps = BoxProps;

const Page = (props: PageProps) => {
  return <Box display="flex" flexDirection="column" minHeight="100%" {...props} />;
};

export default Page;
